import { getCompetitorGameCountryPublisher } from '@/pages/opinion/services';
import { useEffect, useState } from 'react';

export default function useGameCountryPublisher({ selected, mainGame }: any) {
  const [gameCountryMap, setGameCountryMap] = useState<any>({});

  useEffect(() => {
    let games = [...(selected || [])];
    if (mainGame && Object.keys(mainGame).length > 0) {
      games.push(mainGame);
    }
    games = games
      .filter(
        (item) =>
          item.country === '' && !gameCountryMap[item.edition_unified_id],
      )
      .map((item) => ({
        edition_unified_id: item.edition_unified_id,
        id_type: item.id_type,
        entity_type: item.entity_type,
      }));

    if (games.length > 0) {
      getCompetitorGameCountryPublisher({ games }).then((data: any) => {
        const localGameCountryMap = data?.reduce((pre: any, cur: any) => {
          const { game, value } = cur;
          return { ...pre, [game.edition_unified_id]: value };
        }, {});
        setGameCountryMap({ ...gameCountryMap, ...localGameCountryMap });
      });
    }
  }, [selected, mainGame]);

  return {
    gameCountryMap,
  };
}
